<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Reabrir para edição</h2>
    <span class="modal-subtitle">NF-e {{ data.numeroNota }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <app-alert-card type="info">
    A nota volta para Em lançamento, recebe o badge "Reaberta" e mantém o histórico completo.
  </app-alert-card>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Justificativa</mat-label>
    <textarea
      matInput
      rows="4"
      maxlength="500"
      [formControl]="justificativa"
      placeholder="Informe o motivo da reabertura"></textarea>
    <mat-hint align="end">{{ justificativa.value.length }}/500</mat-hint>
    @if (justificativa.hasError('required') || justificativa.hasError('minlength')) {
      <mat-error>Informe ao menos 10 caracteres.</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" type="button" (click)="confirmar()">
    Reabrir
  </button>
</mat-dialog-actions>
